export const ARIA_LABEL = {
  summaryModeEnabled: 'Toggle on Comparison Mode',
  comparisonModeEnabled: 'Toggle off Comparison Mode (return to Summary Mode)',
}
